// ShopProfile specific translations
export const shopProfileTranslations = {
  en: {
    loading: "Loading shop profile...",
    notFound: "Shop Not Found", 
    notFoundDescription: "The coffee shop you're looking for doesn't exist or has been removed.",
    backToHome: "Back to Home",
    share: "Share Shop",
    viewMenu: "View Menu",
    about: "About",
    specialties: "Specialties", 
    contactInfo: "Contact Information",
    recentPosts: "Recent Posts",
    followUs: "Follow Us",
    businessHours: "Business Hours",
    products: "Products",
    tables: "Tables",
    posts: "Posts",
    noPostsYet: "No Posts Yet",
    noPostsDescription: "This shop hasn't shared any posts yet.",
    gallery: "Gallery",
    website: "Website",
    instagram: "Instagram", 
    facebook: "Facebook",
    twitter: "Twitter",
    // Additional keys for complete coverage
    linkCopied: "Link copied to clipboard!",
    shopLinkCopied: "Shop link copied to clipboard!",
    failedToCopyShopLink: "Failed to copy shop link",
    noAddress: "Address not provided",
    viewMore: "View More",
    showLess: "Show Less",
    menuPreview: "Menu Preview",
    notAvailable: "N/A",
    // Business hours status
    open: "Open",
    closed: "Closed",
    openingSoon: "Opening Soon",
    closingSoon: "Closing Soon",
    checkHours: "Check Hours",
    // Days of the week
    monday: "Monday",
    tuesday: "Tuesday", 
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday"
  },
  fr: {
    loading: "Chargement du profil du café...",
    notFound: "Café Introuvable",
    notFoundDescription: "Le café que vous recherchez n'existe pas ou a été supprimé.", 
    backToHome: "Retour à l'Accueil",
    share: "Partager le Café",
    viewMenu: "Voir le Menu", 
    about: "À Propos",
    specialties: "Spécialités",
    contactInfo: "Informations de Contact",
    recentPosts: "Publications Récentes", 
    followUs: "Suivez-nous",
    businessHours: "Heures d'Ouverture",
    products: "Produits",
    tables: "Tables", 
    posts: "Publications",
    noPostsYet: "Aucune Publication Encore",
    noPostsDescription: "Ce café n'a pas encore partagé de publications.",
    gallery: "Galerie d'Images",
    website: "Site Web",
    instagram: "Instagram",
    facebook: "Facebook", 
    twitter: "Twitter",
    // Additional keys for complete coverage
    linkCopied: "Lien copié dans le presse-papiers !",
    shopLinkCopied: "Lien du café copié dans le presse-papiers !",
    failedToCopyShopLink: "Échec de la copie du lien du café",
    noAddress: "Adresse non fournie",
    viewMore: "Voir Plus",
    showLess: "Voir Moins", 
    menuPreview: "Aperçu du Menu",
    notAvailable: "N/A",
    // Business hours status
    open: "Ouvert",
    closed: "Fermé",
    openingSoon: "Ouverture Bientôt",
    closingSoon: "Fermeture Bientôt",
    checkHours: "Vérifier les Heures",
    // Days of the week
    monday: "Lundi",
    tuesday: "Mardi",
    wednesday: "Mercredi", 
    thursday: "Jeudi",
    friday: "Vendredi",
    saturday: "Samedi",
    sunday: "Dimanche"
  },
  es: {
    loading: "Cargando perfil del café...",
    notFound: "Café No Encontrado",
    notFoundDescription: "El café que buscas no existe o ha sido eliminado.",
    backToHome: "Volver al Inicio", 
    share: "Compartir Café",
    viewMenu: "Ver Menú",
    about: "Acerca de",
    specialties: "Especialidades",
    contactInfo: "Información de Contacto",
    recentPosts: "Publicaciones Recientes",
    followUs: "Síguenos", 
    businessHours: "Horario de Atención",
    products: "Productos",
    tables: "Mesas",
    posts: "Publicaciones",
    noPostsYet: "Sin Publicaciones Aún", 
    noPostsDescription: "Esta cafetería no ha compartido publicaciones aún.",
    gallery: "Galería de Imágenes",
    website: "Sitio Web",
    instagram: "Instagram",
    facebook: "Facebook",
    twitter: "Twitter",
    // Additional keys for complete coverage  
    linkCopied: "¡Enlace copiado al portapapeles!",
    shopLinkCopied: "¡Enlace del café copiado al portapapeles!",
    failedToCopyShopLink: "Error al copiar enlace del café",
    noAddress: "Dirección no proporcionada",
    viewMore: "Ver Más",
    showLess: "Ver Menos",
    menuPreview: "Vista Previa del Menú",
    notAvailable: "N/A",
    // Business hours status
    open: "Abierto",
    closed: "Cerrado",
    openingSoon: "Abriendo Pronto",
    closingSoon: "Cerrando Pronto",
    checkHours: "Consultar Horarios",
    // Days of the week
    monday: "Lunes",
    tuesday: "Martes",
    wednesday: "Miércoles",
    thursday: "Jueves", 
    friday: "Viernes",
    saturday: "Sábado",
    sunday: "Domingo"
  },
  ar: {
    loading: "جاري تحميل ملف المقهى...",
    notFound: "المقهى غير موجود",
    notFoundDescription: "المقهى الذي تبحث عنه غير موجود أو تم حذفه.",
    backToHome: "العودة للرئيسية",
    share: "مشاركة المقهى", 
    viewMenu: "عرض القائمة",
    about: "حول",
    specialties: "التخصصات",
    contactInfo: "معلومات الاتصال",
    recentPosts: "المنشورات الحديثة",
    followUs: "تابعونا",
    businessHours: "ساعات العمل",
    products: "المنتجات", 
    tables: "الطاولات",
    posts: "المنشورات",
    noPostsYet: "لا توجد منشورات بعد",
    noPostsDescription: "هذا المقهى لم يشارك أي منشورات بعد.",
    gallery: "المعرض",
    website: "الموقع الإلكتروني",
    instagram: "إنستغرام",
    facebook: "فيسبوك",
    twitter: "تويتر",
    // Additional keys for complete coverage
    linkCopied: "تم نسخ الرابط!",
    shopLinkCopied: "تم نسخ رابط المقهى!",
    failedToCopyShopLink: "فشل في نسخ رابط المقهى",
    noAddress: "العنوان غير متوفر",
    viewMore: "عرض المزيد",
    showLess: "عرض أقل",
    menuPreview: "معاينة القائمة",
    notAvailable: "غير متاح",
    // Business hours status
    open: "مفتوح",
    closed: "مغلق",
    openingSoon: "يفتح قريباً",
    closingSoon: "يغلق قريباً",
    checkHours: "تحقق من الساعات",
    // Days of the week
    monday: "الاثنين",
    tuesday: "الثلاثاء",
    wednesday: "الأربعاء",
    thursday: "الخميس",
    friday: "الجمعة",
    saturday: "السبت",
    sunday: "الأحد"
  }
};
